// Итог шага бота (executeBotStep) — для исполнителей, которым важно, что именно
// произошло (темп хода строительства, см. online/constructionTurnPacing).
// Остальные вызовы итог не читают
export const BOT_STEP_RESULTS = {
  // Бот сделал игровое действие
  ACTED: 'acted',
  // Действий больше нет, но завершение фазы отложено (phaseCompletion: DEFER)
  READY_TO_COMPLETE: 'ready_to_complete',
  // Бот завершил фазу (этап)
  COMPLETED: 'completed',
  // Бот хочет купить политику, но покупка придержана (holdPolicyPurchase):
  // шаг ничего не сделал
  POLICY_PURCHASE_WANTED: 'policy_purchase_wanted',
};

// Завершение фазы строительства в шаге бота (options.phaseCompletion):
//  - AUTO — как обычно: нет действий — фаза завершается тем же шагом;
//  - DEFER — нет действий — шаг возвращает READY_TO_COMPLETE, не завершая;
//  - FORCE — без решений: фаза сразу завершается.
// В остальных фазах шаг всегда ведет себя как AUTO
export const BOT_PHASE_COMPLETION_MODES = {
  AUTO: 'auto',
  DEFER: 'defer',
  FORCE: 'force',
};
